import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type QuestionAnswer = {
    question_id: number;
    answer_id: number;
};

const CauserieContext = createContext<CauserieContextType | undefined>(undefined);

export type CauserieContextType = {
    signature: string | null;
    setSignature: (signature: string) => void;
    requestUser: string | null;
    setRequestUser: (requestUser: string) => void;
    questionsAnswers: QuestionAnswer[];
    setQuestionsAnswers: (answers: QuestionAnswer[]) => void;
    score: number | null;
    setScore: (score: number) => void;
};

type CauserieProviderProps = {
    children: ReactNode;
};

export const CauserieProvider: React.FC<CauserieProviderProps> = ({ children }) => {
    const [signature, setSignature] = useState<string | null>(null);
    const [requestUser, setRequestUser] = useState<string | null>(null);
    const [questionsAnswers, setQuestionsAnswers] = useState<QuestionAnswer[]>([]);
    const [score, setScore] = useState<number | null>(null);
    const location = useLocation();

    useEffect(() => {
        if (!location.pathname.includes('/causeries') || location.pathname === '/sante-securite/causeries/list') {
            setRequestUser(null);
            setSignature(null);
            setQuestionsAnswers([]);
            setScore(null);
        }
    }, [location.pathname]);

    const value = {
        signature,
        setSignature,
        requestUser,
        setRequestUser,
        questionsAnswers,
        setQuestionsAnswers,
        score,
        setScore
    };

    return <CauserieContext.Provider value={value}>{children}</CauserieContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useCauserie = () => {
    const context = useContext(CauserieContext);
    if (context === undefined) {
        throw new Error('useCauserie must be used within a CauserieProvider');
    }

    return context;
};
